import { render, staticRenderFns } from "./DEXT5UploadForMr.vue?vue&type=template&id=4f8e674e&scoped=true"
import script from "./DEXT5UploadForMr.vue?vue&type=script&lang=js"
export * from "./DEXT5UploadForMr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8e674e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f8e674e')) {
      api.createRecord('4f8e674e', component.options)
    } else {
      api.reload('4f8e674e', component.options)
    }
    module.hot.accept("./DEXT5UploadForMr.vue?vue&type=template&id=4f8e674e&scoped=true", function () {
      api.rerender('4f8e674e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/DEXT5UploadForMr.vue"
export default component.exports